import React from 'react';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import Features from './sections/Features';
import SocialProof from './sections/SocialProof';
import Pricing from './sections/Pricing';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <SocialProof />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
}
